import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RegisterPayload } from '../shared/interfaces/user.interface';
import { AuthService } from '../shared/services/auth';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
resetForm!: FormGroup;
  token!: string;
  message: string = '';
  isSubmitting = false;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private notificationService: ToastrService,
    private spinnerSvc: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'] || '';
    });

    this.resetForm = this.fb.group({
      password: [''],
      mpin: ['']
    });
  }

  onSubmit(): void {
    if (!this.token) {
     this.notificationService.error('Invalid or missing token. Please check your reset link.');
      return;
    }

    const { password, mpin } = this.resetForm.value;

    if (!password && !mpin) {
      this.notificationService.warning('⚠️ Please enter either Password or MPIN.');
      return;
    }

    const payload : RegisterPayload = {
      token: this.token,
      newPassword: password || null,
      newMpin: mpin || null
    };

    this.isSubmitting = true;
    this.spinnerSvc.show();
   this.authService.resetPassword(payload).subscribe({
      next: (response) => {
        if(response.message){
          this.isSubmitting = false;  
          this.notificationService.success('✅ Password/MPIN reset successfully.');
          this.resetForm.reset();
          this.spinnerSvc.hide();
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        this.notificationService.error(err.error?.message || '❌ Reset failed. Try again.');
        this.spinnerSvc.hide();
      }
    });
  }
}
